module.exports = __webpack_public_path__ + "media/partners/beiersdorf-cbdfcb2d.svg";